import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import eventService from '../../common/eventService';
import VersionHistoryList from './VersionHistoryList';
import rules from '../../constants/businessRules/businessRules';
import configs from '../../constants/configs';
import * as versionHistoryActions from '../../actions/versionHistory';
import { ERR_VERSION_HISTORY_LOAD } from '../../constants/Errors';
import * as Styled from './styles';
import { request } from '../../common/request';

const VersionHistoryLeftPanel = ({ documentID, versionHistory, isVersionHistoryLoaded, loadVersionHistoryItem, dispatch }) => {
    const [offset, setOffset] = useState(0);
    const [hasItemsToBeFetched, setHasItemsToBeFetched] = useState(true);

    const loadVersionHistory = useCallback(() => {
        (async () => {
            try {
                const versionHistoryArr = await request.get(`${configs.versionHistory}?documentID=${documentID}&quantity=${rules.VERSION_HISTORY_LOAD_BATCH_SIZE}&offset=${offset}`);
                if (versionHistoryArr.length < rules.VERSION_HISTORY_LOAD_BATCH_SIZE) {
                    setHasItemsToBeFetched(false);
                }
                dispatch(versionHistoryActions.updateVersionHistory({ items: versionHistoryArr }));
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(err);
                eventService.notify(err.customMessage ? err.customMessage : ERR_VERSION_HISTORY_LOAD, true);
            }
        })();
    }, [documentID, offset, dispatch]);

    useEffect(() => {
        loadVersionHistory();
    }, [offset, loadVersionHistory]);

    useEffect(() => () => {
        dispatch(versionHistoryActions.clearVersionHistory());
    }, [dispatch]);

    const lazyLoadMoreVersionHistoryItems = () => {
        if (hasItemsToBeFetched) {
            setOffset(offset + rules.VERSION_HISTORY_LOAD_BATCH_SIZE);
        }
    };

    return (
        <Styled.LeftPanelDiv>
            <Styled.LeftPanelInnerDiv>
                <VersionHistoryList
                    versionHistory={isVersionHistoryLoaded && versionHistory.length !== 0 ? versionHistory : Array(6).fill({})} // loading skeleton items
                    isVersionHistoryLoaded={isVersionHistoryLoaded}
                    loadVersionHistoryItem={loadVersionHistoryItem}
                    lazyLoadMoreVersionHistoryItems={lazyLoadMoreVersionHistoryItems}
                />
            </Styled.LeftPanelInnerDiv>
        </Styled.LeftPanelDiv>
    );
};

const mapStateToProps = (state) => ({
    documentID: (_get(state, 'session.collaboration.type', '') === 'template' ? 't' : 'd')
        + _get(state, 'session.collaboration.id', '')
        + _get(state, 'session.collaboration.versionID', '')
        + _get(state, 'session.collaboration.trackID', ''),
    versionHistory: _get(state, 'versionHistory.versionHistory', []),
    isVersionHistoryLoaded: _get(state, 'versionHistory.isVersionHistoryLoaded', false),
});

VersionHistoryLeftPanel.propTypes = {
    documentID: PropTypes.string.isRequired,
    versionHistory: PropTypes.array.isRequired,
    isVersionHistoryLoaded: PropTypes.bool.isRequired,
    loadVersionHistoryItem: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(VersionHistoryLeftPanel);
